import { SPROUT_AGENT } from '@fruitful/llm-service-shared';
import { useQuery } from '@tanstack/react-query';

import { captureException } from '../../logger/Logger';
import { useMastraClient } from '../providers/MastraClient';

const QA_SIMULATION_THREADS_PAGE_SIZE = 500;

export const useSproutQASimulationThreads = (
    refetchInterval: number | false = false,
) => {
    const mastraClient = useMastraClient();

    return useQuery({
        queryKey: ['sproutQASimulationThreads', SPROUT_AGENT.id],
        queryFn: async () => {
            try {
                const response = await mastraClient.listMemoryThreads({
                    agentId: SPROUT_AGENT.id,
                    metadata: {
                        sessionKind: 'simulation',
                    },
                    orderBy: { field: 'updatedAt', direction: 'DESC' },
                    perPage: QA_SIMULATION_THREADS_PAGE_SIZE,
                });

                return response.threads;
            } catch (err) {
                if (err instanceof Error) {
                    captureException(err);
                }

                throw err;
            }
        },
        refetchInterval,
        refetchOnWindowFocus: false,
    });
};
